import React from 'react';
import { Link } from 'react-router-dom';
import { Diamond } from 'lucide-react';
import { FOOTER_LINKS } from '../mock';
import Newsletter from './Newsletter';

const Footer = () => {
  return (
    <footer className="bg-[#1B1D21] text-[#d6e0ea]">
      <div className="max-w-7xl mx-auto px-5 pt-16 pb-10">
        <div className="grid gap-12 md:grid-cols-5">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-3">
              <span className="relative flex items-center justify-center w-8 h-8">
                <span className="absolute inset-0 rotate-45 rounded-[6px] sunset-gradient" />
                <Diamond className="relative w-4 h-4 text-white" strokeWidth={2.5} />
              </span>
              <span className="font-display text-[21px] font-semibold text-white">
                Emirates Guide
              </span>
            </Link>
            <p className="mt-5 max-w-sm text-[15px] leading-relaxed text-[#9fb2c4]">
              An independent United Arab Emirates travel and relocation guide — visas,
              hotels, culture and real cost-of-living numbers, kept current and always
              honest about what’s sponsored.
            </p>
            <p className="mt-5 text-[13px] text-[#7f93a6]">
              Not affiliated with Emirates airline. “Emirates” refers to the country.
            </p>
            <div className="mt-7 max-w-sm">
              <Newsletter variant="dark" />
            </div>
          </div>

          {/* Link columns */}
          {FOOTER_LINKS.map((col) => (
            <div key={col.title}>
              <h4 className="text-[13px] font-semibold tracking-[0.14em] uppercase text-[#CBA344]">
                {col.title}
              </h4>
              <ul className="mt-4 space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      className="text-[15px] text-[#c3d1de] hover:text-white transition-colors"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[13px] text-[#7f93a6]">
            © {new Date().getFullYear()} Emirates Guide. Independent &amp; disclosed.
          </p>
          <p className="text-[13px] text-[#7f93a6]">
            Some links are affiliate links — see our{' '}
            <Link to="/about" className="underline underline-offset-2 hover:text-white">
              full disclosure
            </Link>
            .
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
